import { Box } from '@mui/material';

const Wrapper = (props) => {
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: props.maxWidth,
        padding: '34px 66px',
        boxShadow:
          '0px 100px 80px rgba(0, 0, 0, 0.1), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0718854), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0596107), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.05), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0403893), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0281146)'
      }}
      {...props}>
      {props.children}
    </Box>
  );
};
export default Wrapper;
